<template>
    <div>
        <p :class="{'red--text':rule}">{{label}} {{required ? ' *': ''}}</p>
        <FilePond
                name="file"
                ref="input"
                :maxFiles="max || 1"
                :allowMultiple="allowMultiple"
                allowFileTypeValidation="true"
                :acceptedFileTypes="type"
                :server="{  process, revert,  restore, load, fetch }"
                :files="files2"
                @init="handleFilePondInit"
                labelTapToCancel="Toca para cancelar"
                labelButtonAbortItemLoad = "Cancelar descarga"
                labelButtonRemoveItem = "Borrar archivo"
                labelButtonRetryItemLoad="Cargando"
                labelButtonRetryItemProcessing ="Reintentar"
                labelButtonUndoItemProcessing ="Deshacer"
                labelDecimalSeparator =","
                labelFileAdded = "Archivo Añadido"
                labelFileCountPlural ="Archivos"
                labelFileCountSingular ="Archivo"
                labelFileLoadError ="Error al subir"
                labelFileLoading ="Cargando"
                labelFileProcessing ="Subiendo"
                labelFileProcessingAborted ="Subida cancelada"
                labelFileProcessingComplete ="Subida completa"
                labelFileProcessingError ="Error al subir archivo"
                labelFileRemoved="Archivo eliminado"
                labelFileSizeNotAvailable ="Tamaño no disponible"
                labelFileWaitingForSize ="Comprobando tamaño"
                labelIdle ="Arrastre un archivo o pulse aqui"
                labelTapToRetry="Toca para reintentar"
                labelTapToUndo="Toca para deshacer"
                labelThousandsSeparator=""

        />
        <p v-if="rule" class="caption red--text">Archivo requerido</p>

    </div>
</template>

<script>
    import FilePond, { registerPlugin } from 'vue-filepond';

    // Register a plugin
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
    registerPlugin(FilePondPluginFileValidateType);
    registerPlugin(FilePondPluginFileValidateSize);

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';

    export default {
        name: "file-input",
        props: ['label', 'required', 'max', 'type'],
        data: function() {
            return {
                first: true,
                files: [],
                files2: [], };

        },
        computed: {
            allowMultiple () {
                return this.max !== 1
            },
            rule () {
                return this.required && !this.first && this.files.length === 0
            }
        },
        methods: {
            process  (fieldName, file, metadata, load, error, progress, abort)  {
                var self = this
                try {
                    progress(true, 0, 1024);
                    var uploadTask = this.$storage.ref().child('images/' + (new Date().getTime()) +  file.name).put(file, metadata)
                    uploadTask.on(this.$firebase.storage.TaskEvent.STATE_CHANGED,
                        function (snapshot) { progress(true, snapshot.bytesTransferred, snapshot.totalBytes)},
                        function (e) {  self.handleError(error, e)},
                        function () {
                            load(uploadTask.snapshot.ref.fullPath)
                            self.files.push(uploadTask.snapshot.ref.fullPath)
                        }
                    )
                    return {
                        abort: () => {
                            abort()
                            uploadTask.cancel();
                        }
                    }
                } catch (e) {
                    this.handleError(error, e)
                    return {
                        abort: () => { abort() }
                    }
                }
            },
            revert (uniqueFileId, load, error) {
                var self = this
                // Create a reference to the file to delete
                console.log(uniqueFileId)
                var desertRef = this.$storage.ref().child(uniqueFileId);
                        desertRef.delete().then(function() {
                            var index = self.files.indexOf(uniqueFileId);
                            if (index > -1) {
                                self.files.splice(index, 1);
                            }
                            load();
                        }).catch(function(e) {
                           this.handleError(error, e)
                        });
            },
            load (uniqueFileId, load, error){ error()},
            fetch (url, load, error, progress, abort, headers) {   error("Solo archivos locales")   },
            restore (uniqueFileId, load, error, progress, abort, headers) { error() },
            handleError (error, e){
                switch (e.code) {
                    case 'storage/canceled':
                        break;
                    default: error(e.message)
                }
            },
            handleFilePondInit: function() {
                this.$refs.input.getFiles();
            }
        },
        watch:{
            files : {
                handler: function (val, oldVal) {
                    if(this.first) this.first = false;
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        components: {
            FilePond
        }
    }
</script>